<div class="container-fluid px-4 mt-4 mb-5">
    <!-- Page Header -->
    <div class="cp-page-header mb-4">
        <div class="cp-page-title">
            <i class="fa-solid fa-sitemap me-2"></i>
            Gestión de Dependencias
        </div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a routerLink="/control-ingreso">Control de Ingreso</a></li>
                <li class="breadcrumb-item active">Dependencias</li>
            </ol>
        </nav>
    </div>

    <div class="row">
        <div class="col-xl-12">
            <div class="card h-100">
                <div class="card-header cp-list-header">
                    <span class="cp-list-title">Listado de Dependencias</span>
                    <div class="btn-group btn-group-sm" role="group">
                        <button type="button" class="btn btn-primary" (click)="openModal(addClient)">
                            <i class="fa-solid fa-circle-plus me-1"></i> Nueva
                        </button>
                    </div>
                </div>

                <div class="card-body">
                    <!-- Filter Panel -->
                    <div class="cp-filter-panel" [formGroup]="form">
                        <div class="row">
                            <div style="flex: 1 1 300px;">
                                <label class="form-label">Buscar Dependencia</label>
                                <app-toolbar-search [placeholder]="'Nombre o RUT'" [hideFilter]="true" (onEmptyInput)="clean()" (onSearch)="search($event)"/>
                            </div>
                            <div style="flex: 0 1 200px;">
                                <label class="form-label">Instalación</label>
                                <select class="form-select" (change)="search()" formControlName="facility_id">
                                    <option [value]="0">Todas las instalaciones</option>
                                    <option *ngFor="let item of facilityes" [value]="item?.id">{{item?.name | uppercase}}</option>
                                </select>
                            </div>
                            <div style="flex: 0 1 120px;">
                                <button type="button" class="btn btn-outline-secondary w-100" (click)="clean()">
                                    <i class="fa-solid fa-rotate-left me-1"></i> Limpiar
                                </button>
                            </div>
                        </div>
                    </div>

                    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage"
                        (pageChange)="search()"></ngb-pagination>
                    <div class="table-responsive">
                        <table class="table cp-table">
                            <thead>
                                <tr>
                                    <th><span>NOMBRE</span></th>
                                    <th><span>RUT</span></th>
                                    <th class="cp-table-hide-mobile"><span>TELEFONO</span></th>
                                    <th class="cp-table-hide-mobile"><span>EMAIL</span></th>
                                    <th class="cp-table-hide-mobile"><span>FECHA CREACIÓN</span></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of items">
                                    <td>
                                        <span>{{item?.name | uppercase}}</span><br>
                                        <span *ngIf="item?.hide_rounds==1" class="badge bg-danger"> <small><i class="fa-solid fa-eye-slash"></i> Rondas Ocultas</small></span>
                                    </td>
                                    <td>
                                        <span>{{item?.rut | uppercase}}</span>
                                    </td>
                                    <td>
                                        <span>{{item?.phone | uppercase}}</span>
                                    </td>
                                    <td>
                                        <span>{{item?.email | lowercase}}</span>
                                    </td>
                                    <td>
                                        {{item?.created_at}}
                                    </td>
                                    <td>
                                        <div class="btn-group" role="group">
                                            <button type="button" class="btn   text-warning"
                                                (click)="goToUpdate(item.id)">

                                                <i class="fa fa-pencil"></i>

                                            </button>
                                            <button type="button" class="btn  text-danger"
                                                (click)="openDelete(item.id,remove)">

                                                <i class="fa-solid fa-trash"></i>

                                            </button>
                                        </div>

                                    </td>
                                </tr>
                            </tbody>
                            <tbody *ngIf="items?.length==0">
                                <tr>
                                    <td colspan="7" class="fw-lighter text-muted">No se encontraron registros</td>
                                </tr>
                            </tbody>
                        </table>
                        <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage"
                            (pageChange)="search()"></ngb-pagination>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <ng-template #remove let-c="close" let-d="dismiss">
        <form (submit)="delete()" novalidate [formGroup]="formDelete">
            <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">Eliminar registro</h4>
                <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>¿Esta seguro que desea eliminar este registro?</p>
                <div class="alert alert-warning"><strong>Importante</strong> Esta operación eliminara todas las
                    dependencias, usuarios administradores y registros asociados, no puede ser restaurada</div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="d('Cross click')">No</button>
                <button type="submit" ngbAutofocus class="btn btn-danger">Si</button>
            </div>
        </form>
    </ng-template>

    <ng-template #addClient let-c="close " let-d="dismiss">
        <div class="modal-body shadow-lg">
            <app-add-store (success)="get()"></app-add-store>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </ng-template>
    <ng-template #editClient let-c="close " let-d="dismiss">
        <div class="modal-body shadow-lg">
            <app-edit-store [template]="null" (success)="get()"></app-edit-store>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </ng-template>